import {ActionCreatorDefinition, createAction} from "redux-ts";
import {AccountInfo} from "core/redux/account/AccountReduxState";
import PromotionOverview from "enum/PromotionOverview";
import {CreditPromo} from "protocol/account/GetAccountStateResponse";
import {CreditPromoStatus} from "protocol/promo/CreditPromoStatus";
import Parameter from "platform/util/Parameter";
import {UserActivityType} from "enum/UserActivityType";
import {RouteType} from "core/router/Routes";
import {BIEventReferrer} from "enum/BIEventReferrer";
import {StringPayload} from "core/redux/StoreActions";
import {MobilePlatformType} from "protocol/auth/LoginRequest";
import {AccountDetailsConfig} from "core/util/AccountDetailsMeta";
import {AccountConfigType} from "enum/AccountConfigType";
import {PropAccountHistory} from "protocol/account/GetUserPropTradingHistory";

export const SetAccountInfoType: string = "SetAccountInfo";
export const SetAccountPendingDeletionType: string = "SetAccountPendingDeletion";
export const SetPromotionsChangedType: string = "SetPromotionsChanged";
export const SetPromotionOverviewType: string = "SetPromotionOverview";
export const TogglePromotionsDetailsType: string = "TogglePromotionsDetails";
export const OnProcessCreateTradeButtonType: string = "OnProcessCreateTradeButton";
export const OnProcessTopUpButtonType: string = "OnProcessTopUpButton";
export const DoAcceptCreditPromoType: string = "DoAcceptCreditPromo";
export const DoRegisterUserActivityType: string = "DoRegisterUserActivity";
export const SendUserFeedbackType: string = "SendUserFeedback";
export const CallMeDoRequestType: string = "CallMeDoRequest";
export const SetShowReviewModalType: string = "SetShowReviewModal";
export const DoRateAppType: string = "DoRateApp";
export const DoActivateBonusCodeType: string = "DoActivateBonusCode";
export const UpdateAccountDetailsConfigType: string = "UpdateAccountDetailsConfig";
export const SetRebatePlanAmountType: string = "SetRebatePlanAmount";
export const GetUserPropTradingHistoryType: string = "GetUserPropTradingHistory";
export const SetUserPropTradingHistoryType: string = "SetUserPropTradingHistory";

export interface SetAccountInfoPayload {

    accountInfo: AccountInfo;
}

export interface SetPromotionsChangedPayload {

    changed: boolean;
}

export interface SetPromotionOverviewPayload {

    promotionOverview: PromotionOverview;
}

export interface OnProcessCreateTradeButtonPayload {

    action?: (routeType: RouteType) => void;
}

export interface OnProcessTopUpButtonPayload {

    parameters?: Parameter[];
    referrer?: BIEventReferrer;
    action?: (routeType: RouteType, parameters?: Parameter[]) => void;
}

export interface DoAcceptCreditPromoPayload {

    promo: CreditPromo;
    status: CreditPromoStatus;
}

export interface DoRegisterUserActivityPayload {

    userActivity: UserActivityType | number;
    comment?: string;
    specificData?: string | number;
}

export interface SendUserFeedbackPayload {

    rate: number;
    comment: string;
    view: string;
    fromDpk: boolean;
    onSuccess?: () => void;
    onFail?: () => void;
}

export interface SetShowReviewModalPayload {

    showModal: boolean;
}

export interface DoRateAppPayload {

    rate?: number;
    comment?: string;
    notNow: boolean;
    mobilePlatformType: MobilePlatformType;
}

export interface UpdateAccountDetailsConfigPayload {

    config: AccountDetailsConfig[];
    key: AccountConfigType;
}

export interface SetRebatePlanAmountPayload {

    rebate: number;
}

export interface SetUserPropTradingHistoryPayload {

    accounts: PropAccountHistory[];
}

export interface GetUserPropTradingStatePayload {

    accountId?: number;
}

export interface SetChangedPropTradingStatusPayload {

    accountId: number;
    status: number;
}

export const SetAccountPendingDeletion: ActionCreatorDefinition<any, any> = createAction<any>(SetAccountPendingDeletionType);
export const SetAccountInfo: ActionCreatorDefinition<SetAccountInfoPayload, any> = createAction<SetAccountInfoPayload>(SetAccountInfoType);
export const SetPromotionsChanged: ActionCreatorDefinition<SetPromotionsChangedPayload, any> = createAction<SetPromotionsChangedPayload>(SetPromotionsChangedType);
export const SetPromotionOverview: ActionCreatorDefinition<SetPromotionOverviewPayload, any> = createAction<SetPromotionOverviewPayload>(SetPromotionOverviewType);
export const TogglePromotionsDetails: ActionCreatorDefinition<any, any> = createAction<any>(TogglePromotionsDetailsType);
export const OnProcessCreateTradeButton: ActionCreatorDefinition<OnProcessCreateTradeButtonPayload, any> = createAction<OnProcessCreateTradeButtonPayload>(OnProcessCreateTradeButtonType);
export const OnProcessTopUpButton: ActionCreatorDefinition<OnProcessTopUpButtonPayload, any> = createAction<OnProcessTopUpButtonPayload>(OnProcessTopUpButtonType);
export const DoAcceptCreditPromo: ActionCreatorDefinition<DoAcceptCreditPromoPayload, any> = createAction<DoAcceptCreditPromoPayload>(DoAcceptCreditPromoType);
export const DoRegisterUserActivity: ActionCreatorDefinition<DoRegisterUserActivityPayload, any> = createAction<DoRegisterUserActivityPayload>(DoRegisterUserActivityType);
export const SendUserFeedback: ActionCreatorDefinition<SendUserFeedbackPayload, any> = createAction<SendUserFeedbackPayload>(SendUserFeedbackType);
export const CallMeDoRequest: ActionCreatorDefinition<any, any> = createAction<any>(CallMeDoRequestType);
export const SetShowReviewModal: ActionCreatorDefinition<SetShowReviewModalPayload, any> = createAction<SetShowReviewModalPayload>(SetShowReviewModalType);
export const DoRateApp: ActionCreatorDefinition<DoRateAppPayload, any> = createAction<DoRateAppPayload>(DoRateAppType);
export const DoActivateBonusCode: ActionCreatorDefinition<StringPayload, any> = createAction<StringPayload>(DoActivateBonusCodeType);
export const UpdateAccountDetailsConfig: ActionCreatorDefinition<UpdateAccountDetailsConfigPayload, any> = createAction<UpdateAccountDetailsConfigPayload>(UpdateAccountDetailsConfigType);
export const SetRebatePlanAmount: ActionCreatorDefinition<SetRebatePlanAmountPayload, any> = createAction<SetRebatePlanAmountPayload>(SetRebatePlanAmountType);
export const GetUserPropTradingHistory: ActionCreatorDefinition<any, any> = createAction<any>(GetUserPropTradingHistoryType);
export const SetUserPropTradingHistory: ActionCreatorDefinition<SetUserPropTradingHistoryPayload, any> = createAction<SetUserPropTradingHistoryPayload>(SetUserPropTradingHistoryType);
